import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=527b56f8&scoped=true"
import script from "./goBack.vue?vue&type=script&lang=js"
export * from "./goBack.vue?vue&type=script&lang=js"
import style0 from "./goBack.vue?vue&type=style&index=0&id=527b56f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b56f8",
  null
  
)

export default component.exports